import ProcessTableArchiveBulkAction from "../BulkActions/ProcessTableArchiveBulkAction";
import ProcessTableAssigneeDropdown from "../BulkActions/ProcessTableAssigneeDropdown";
import ProcessTableStatusDropdown from "../BulkActions/ProcessTableStatusDropdown";
import { ArchivedFilter } from "@avenueops/shared-types";
import { SelectAllState, useSelectAll, useSelectedKeys } from "context/BulkActionsContext";
import { useProcessTableState } from "context/ProcessTableContext";
import { trpc } from "utils/trpc";
import ProcessTablePriorityDropdown from "../BulkActions/ProcessTablePriorityDropdown";

interface Props {
  archived: ArchivedFilter;
  isDashboard: boolean;
}

export function BulkActionsOptions({ archived, isDashboard }: Props): JSX.Element | null {
  const { selectAll, selectAllEnabled, setSelectAll, flipSelectAll } = useSelectAll();
  const selectedProcessIds = useSelectedKeys();
  const hasSelected = selectedProcessIds.length > 0;
  const [{ filters, groupBy, search, sort, timeFrame, timeFrameStartIncl, timeFrameEndExcl }] = useProcessTableState();

  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const countSelectedProcessesOnPage = selectedProcessIds.length;

  const { data: processListAggregates } = trpc.processes.getProcessListAggregates.useQuery({
    filters: filters ?? [],
    groupBy,
    search,
    sort: sort ?? [],
    timeFrame,
    timeFrameStartIncl: timeFrameStartIncl ? timeFrameStartIncl.toString() : undefined,
    timeFrameEndExcl: timeFrameEndExcl ? timeFrameEndExcl.toString() : undefined,
    timeZone,
    archived,
    isDashboard,
  });
  const countAllProcesses = processListAggregates?.count;

  return hasSelected ? (
    <div className="flex gap-2 items-center my-auto text-gray-700">
      <div className="pl-3" />
      <ProcessTableAssigneeDropdown archived={archived} isDashboard={isDashboard} />
      <ProcessTableStatusDropdown archived={archived} isDashboard={isDashboard} />
      <ProcessTableArchiveBulkAction archived={archived} isDashboard={isDashboard} />
      <ProcessTablePriorityDropdown archived={archived} isDashboard={isDashboard} />

      {selectAllEnabled ? (
        <div className="flex items-center gap-1 text-sm">
          {selectAll === SelectAllState.ALL ? (
            <>
              <div>All {countAllProcesses} signals matching these filters are selected.</div>
              <button
                type="button"
                className="rounded font-semibold text-gray-800 px-2 py-1 hover:bg-primary-light"
                onClick={() => setSelectAll(SelectAllState.NOT_SELECTED)}
              >
                Clear Selection
              </button>
            </>
          ) : (
            <>
              <div>All {countSelectedProcessesOnPage} signals on this page are selected. </div>
              {countAllProcesses !== undefined && countSelectedProcessesOnPage < countAllProcesses ? (
                <button
                  type="button"
                  className="rounded font-semibold text-gray-800 px-2 py-1 hover:bg-primary-light"
                  onClick={() => setSelectAll(SelectAllState.ALL)}
                >
                  Select all {countAllProcesses} signals that match these filters.
                </button>
              ) : null}
            </>
          )}
        </div>
      ) : null}
    </div>
  ) : null;
}
